import {
  LoadingAFY,
  position,
  typeAlert,
  typeLoaders,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../../services/toast";
import { themeCore } from "../../../assets/themes/theme";
import React from "react";
import { HeaderTitlePage } from "../../../components/resources/headerTitlePage/headerTitlePage";

export const CustomerHeader = (props: any) => {
  return (
    <>
      <LoadingAFY
        loading={props.loading}
        backgroundColor={themeCore.colors.backgroundLoader}
        typeAnimation={typeLoaders.LogoAfy}
        sizeAnimation={65}
        textLoading={"Cargando..."}
        textLoadingColor={themeCore.colors.third}
        spinnerColor={themeCore.colors.third}
      />
      <HeaderTitlePage
        breadCrumbs={props.breadCrumbs}
        steps={props.stepProgress}
        titlePage={"Validar Cliente"}
        stepsTop={"-22px"}
      />

      {props.seeToast.show &&
        showToast(
          position.topRight,
          props.seeToast.type,
          props.seeToast.message,
          () => {
            props.setSeeToast({
              show: false,
              message: "",
              type: typeAlert.success,
            });
          },
        )}
    </>
  );
};
